import React from 'react';
// mui
import { ArrowBack } from '@mui/icons-material';
import { Box, Card, CardContent, Divider, IconButton } from '@mui/material';
// components
import FullLogo from 'src/assets/logo/logo_full.png';
import Logo from 'src/components/Logo';
import { cardContentStyle, logoBoxStyle } from './OnboardingCard.styles';

type CardProps = React.ComponentProps<typeof Card>;

interface OnboardingCardProps extends CardProps {
  onPreviousStep: () => void;
  displayBackButton?: boolean;
}

const OnboardingCard: React.FC<OnboardingCardProps> = (props) => (
  <Card sx={props.sx}>
    <CardContent sx={cardContentStyle}>
      <Box sx={logoBoxStyle}>
        {props.displayBackButton && (
          <IconButton
            sx={{ top: 20, left: 10, position: 'absolute' }}
            aria-label="delete"
            onClick={props.onPreviousStep}
          >
            <ArrowBack />
          </IconButton>
        )}
        <Logo path={FullLogo} sx={{ width: 150, my: 2 }} />
      </Box>
      <Divider />
      <Box sx={{ flex: 1 }}>{props.children}</Box>
    </CardContent>
  </Card>
);

export default OnboardingCard;
